import React, { useEffect, useState } from "react"
import { apiService } from "../../../api/axiosInstance"
import { Field } from "formik"

import { LoaderSkeleton } from "../../Loaders"
import { MultiSelect } from "primereact/multiselect"

// constants
import { GET } from "../../../config/constants"

import styles from "../../../styles/Form.module.css"

export default function ProductCoverageAreaMsas(props) {
  const { fieldname, label } = props
  const [fetching, setFetching] = useState(true)
  const [options, setOptions] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const response = await apiService.get(`/${GET.PRODUCT_COVERAGE_AREA}`, {
        params: { geo: "msas" },
      })
      setOptions(response.data.data)
      setFetching(false)
    }
    fetchData()
  }, [])

  if (fetching) return <LoaderSkeleton count={1} />

  return (
    <Field name={fieldname}>
      {({ field, meta }) => {
        return (
          <div className={styles.field}>
            <label htmlFor={fieldname} className={styles.label}>
              {label}
            </label>
            <MultiSelect
              id={fieldname}
              options={options}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
            {meta.touched && meta.error && (
              <div className={styles.error}>{meta.error}</div>
            )}
          </div>
        )
      }}
    </Field>
  )
}
